<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="t4">I </span><span class="t5">WOULD</span><span class="t4"> </span>like to thank Willie Larson and the helpful staff of Hennepin County Medical Center for the wonderful input and advice I received. HCMC rocks! </p>
<p class="p4">Thanks to Kristopher Krentz (aka Str8 Cat) for his insightful scene input and character embellishment. </p>
<p class="p4">Mucho thanks to my eagle-eyed beta readers: Ann Hinnenkamp, James (aka Pearle) Gunderson, and Jennifer Hutchins—their helpful notes and suggestions were invaluable. </p>
<p class="p4">A special thank you to Jennifer Hutchins, who tackled the bulk of the research for this book. It was a collaboration I will cherish forever. </p>
<p class="p4">A hug to my partner, Patrick (aka “P”) for extending the leash. You are and always will be the sparkle in my life.</p>
<p class="p4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?43ee34ff